<script setup>
defineProps({
  items: { type: Array, required: true },
});
</script>

<template>
  <ul class="flex flex-col gap-2">
    <li
      v-for="item in items"
      :key="item.label"
      data-test="bar"
      class="flex flex-col gap-1"
    >
      <div class="flex justify-between text-xs">
        <span class="truncate text-n-slate-12">{{ item.label }}</span>
        <span class="tabular-nums text-n-slate-11"
          >{{ Math.round(item.share * 100) }}%</span
        >
      </div>
      <svg
        viewBox="0 0 100 6"
        preserveAspectRatio="none"
        class="h-1.5 w-full"
        aria-hidden="true"
      >
        <rect width="100" height="6" rx="3" class="fill-n-slate-3" />
        <rect
          :width="Math.max(1, item.share * 100)"
          height="6"
          rx="3"
          class="fill-n-blue-9"
        />
      </svg>
    </li>
  </ul>
</template>
